import creationToolContainerSelector from './flocabulary_creation_tool_container_selector'
import saveSelector from './flocabulary_save_selector'
import videoSelector from './flocabulary_current_video_selector'
import searchSelector from './flocabulary_query_selector'

export default {
	creationToolContainerSelector,
	searchSelector,
	saveSelector,
	videoSelector,
}
